import React, { useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'

function Forklifts() {
    
    const [forklifts, setForklifts] = useState([])
    const [showSideBar, setShowSidebar] = useState(false)
    const [selectedForklift, setSelectedForklift] = useState([])
    const [isMobile, setIsMobile] = useState(false)

    const apiURL = process.env.REACT_APP_PUBLIC_API_URL;

    let rules = [
        'Check the forks or attachment are in the lowered position and the park brake is applied.',
        'Observe condition of the forks, and the lock pins or the lifting attachment.',
        'Check the hydraulic lift cylinder and hydraulic hoses for leaks.',
        'Inspect the lift chains for even tension, mast rails and carriage rollers for signs of bearing failure (will appears as silver fleck in the channel of the mast). Give them a pull.',
        'Check the left tilt cylinder, anchor pins and hose connection for leaks.',
        'Check the left front tire condition hub and attaching bolts.',
        'Check front lights, windshield and left side overhead guard. Especially during winter.',
        'Check the left rear tire, hub and attaching bolts and tie rod end.',
        'Check counterweight bolt. Look for rust.',
        'Check propane cylinder is firmly attached, level and make sure the service valve is open.',
        'Check right rear wheel hub and attaching bolts.',
        'Check rear lights and right side overhead guard condition.',
        'Check right side tilt cylinder, anchors and hydraulic connections.',
        'Check right front tire condition hub and attaching bolts',
        'Check the battery is secure and the connections are not corroded. Use wire brush to clean.',
        'Check for oil and coolant leaks. Coolant can be green or orange. Check air filter for debris.',
        'Check the engine and hydraulic oil levels. Header tank needs to be half way full.',
        'Check the hoses and belts. Indication would be squealing after you start it up.',
        'Check the radiator is clear of debris. Especially important in summer due to dust accumulation. Blow it out with compressed air.',
        'Fasten seat belt.',
        'Check the capacity plate (there must be one on the machine).',
        'Check the condition of the overhead guard.',
        'Check the horn, wipers, and signals if applicable.',
        'Start the engine and listen for any unusual noises, observe the dash gauges.',
        'Check the steering, turn the wheel lock to lock. Check the tire condition, no gouges.',
        'Check that the parking brake will hold the machine while in forward and reverse gear.',
        'Check the Hydraulic controls (raise, lowers, tilt, and side to side). If you hear a chattering or growling noise, or it bounces as it goes up it means you’re running low.',
        'Release park brake and check forward (and reverse) travel and foot break operation. Make sure break pedal feels the same way. Back up alarm should sound.'
    ]

    useEffect(()=>{
        getForklifts()
        if(window.innerWidth < 600){
          setIsMobile(true)
        }
    },[])

    
    function getForklifts() {
        fetch( apiURL + '/getForklifts.php')
        .then(response => response.json())
        .then(response => {
            const sortedForklifts = response.sort((a, b) => new Date(b.date) - new Date(a.date));
            setForklifts(sortedForklifts);
        })
    }
    

    function formatDate(date){
        let preFormat = new Date(date).toLocaleDateString('en-US', {
           month: '2-digit',
           day: '2-digit',
           year: 'numeric',
         });
         const dateStr = preFormat
         const dateObj = new Date(dateStr);
         const options = { year: 'numeric', month: 'long', day: 'numeric' };
         const formattedDate = dateObj.toLocaleDateString('en-US', options);
 
         return formattedDate
     }

    function selectForklift(id){
        setShowSidebar(true)
       setSelectedForklift(forklifts[id]);
    }


     return (
        <div className='wrapper-forklifts'>
          <div>
            <Sidebar />
          </div>
          <div className='content'>
            <div className='header'>
              <h1> Forklifts </h1>
              <i className="bi bi-layout-sidebar-inset-reverse iconSidebar" onClick={() => setShowSidebar(!showSideBar)}></i>
            </div>
            <div className='main-grid' style={{ display: showSideBar ? "grid" : "block" }}>
              <div className='forklifts'>
                {forklifts.map((row, key) => (
                  <div key={key} className='row-forklift' onClick={() => selectForklift(key)}>
                    <p id="forklift">{row.forklift}</p>
                    <p id="name" style={{display: isMobile? "none":"block"}}> {row.name} </p>
                    <p id="date"> {formatDate(row.date)} </p>
                  </div>
                ))}
              </div>
              <div className='overlay' style={{display: isMobile && showSideBar ? "block":"none"}}  onClick={()=>setShowSidebar(!showSideBar)}/>
              <div className='sidebar' style={{ display: showSideBar? "block" : "none" }}>
              {selectedForklift.name ? (
                    <div>
                      <p id="forklift">{selectedForklift.forklift}</p>
                      <p id="name">{selectedForklift.name}</p>
                      <p id="date">{formatDate(selectedForklift.date)}</p>
                      {rules.map((rule, index) => (
                        <p className="checks" key={index}>
                          {selectedForklift[`ch${index + 1}`] === '&#9745' ? (
                            <i className="bi bi-check-circle-fill iconCheck"></i>
                          ) : (
                            <i className="bi bi-exclamation-circle-fill iconWarning"></i>
                          )}{' '}
                          {rule}
                        </p>
                      ))}
                    </div>
                ) : (
                  <p className='emptyArray'> Nothing Selected </p>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }
    
    export default Forklifts;